export default {
  install (Vue, options) {
    Vue.mixin({
      data () {
        return {
          v_paginationShow: false,
          v_paginationPage: 1,
          v_paginationLimit: 20,
          v_paginationHasNextPage: false,
          v_paginationPageSizes:[25, 50, 100, 200, 300],
          v_paginationItemsCount: 0,
          v_paginationTotalPages: 0
        }
      },
      computed: {
        paginationCurrentPage () {
          if (this.v_paginationHasNextPage) {
            return this.v_paginationPage - 1 || 1
          } else {
            return this.v_paginationPage
          }
        },
        paginationParamsObject () {
          return {
            page: this.v_paginationPage,
            limit: this.v_paginationLimit
          }
        },
      },
      methods: {
        setPaginationPage (number) {
          this.v_paginationPage = number || 1
        },
        setPaginationLimit (number) {
          this.v_paginationLimit = number || 20
        },
        resetPaginationData () {
          this.v_paginationPage = 1
          this.v_paginationHasNextPage = false
        },
        parsePaginationDataFromResponse (res, totalKey = 'total') {
          this.v_paginationShow = false
          if (totalKey == 'pages') {
            this.v_paginationItemsCount = (res[totalKey] || 1) * this.v_paginationLimit
          } else {
            this.v_paginationItemsCount = res[totalKey] || this.v_paginationLimit
          }
          
          this.v_paginationHasNextPage = res.hasNextPage || false
          if (this.v_paginationHasNextPage) this.v_paginationPage ++

          if(res.total_pages) {
            this.v_paginationTotalPages = res.total_pages
          } else {
            this.v_paginationTotalPages = Math.ceil(this.v_paginationItemsCount / this.v_paginationLimit)
          }

          this.v_paginationShow = true
        },
        paginationPageChanged (page, method, methodParams, reset) {
          if (reset) this.resetPaginationData()
          this.v_paginationPage = page
          this.v_paginationHasNextPage = false
          if (method && typeof method == 'string') {
            try {
              this[method](methodParams)
            } catch (e) {}
          }
        },
        paginationItemIndex (index) {
          if (this.v_paginationHasNextPage) {
            return index + 1 + (this.v_paginationPage * this.v_paginationLimit)
          } else {
            return index + 1 + (this.v_paginationPage - 1 * this.v_paginationLimit)
          }
        }
      }
    })
  }
}
